import React from "react";
import { FaFacebook, FaPlayCircle } from "react-icons/fa";
import littleflockimg1 from "../assets/littleflockimg1.jpg";

const Watch = () => {
  return (
    <section id="watch" className="relative w-full overflow-hidden py-20 px-4 md:py-28">
      <img
        src={littleflockimg1}
        alt="Hands raised in worship during a service"
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ink/75" />

      <div className="relative z-10 mx-auto max-w-2xl text-center text-white">
        <FaPlayCircle className="mx-auto text-terracotta" size={52} />
        <p className="section-label mt-4 text-peach">Watch Online</p>
        <h2 className="mt-3 font-serif text-3xl font-bold sm:text-4xl">
          Can't make it in person?
        </h2>
        <p className="mt-4 text-white/85">
          We stream most of our Sunday services live on Facebook. Follow our page
          so you never miss a message — and worship along with us from wherever
          you are.
        </p>
        <a
          href="https://www.facebook.com/littleflockchurchkitchener"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary mt-8"
        >
          <FaFacebook size={20} />
          Watch on Facebook
        </a>
      </div>
    </section>
  );
};

export default Watch;
